import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/patient-rank";

export const pagingPatientRank = (searchObject) =>
  axios.post(API_PATH + "/search-by-page", searchObject);

export const getPatientRankById = (medicalEquipmentId) =>
  axios.get(API_PATH + "/get-by-id/" + medicalEquipmentId);

export const saveOrUpdatePatientRank = (medicalEquipment) =>
  axios.post(API_PATH + "/save", medicalEquipment);

export const deletePatientRank = (medicalEquipmentId) =>
  axios.delete(API_PATH + "/mark-delete/" + medicalEquipmentId);

export const syncPatientRank = (obj) =>
  axios.post(API_PATH + "/sync-patient-rank", obj);
